module.exports = __webpack_public_path__ + "static/img/new.e848d2dc.png";